type Props = { onBuild: () => void; onSkip: () => void };

export function PlanEmptyHero({ onBuild, onSkip }: Props) {
  return (
    <div
      style={{
        background: 'linear-gradient(135deg, rgba(13,40,24,1) 0%, rgba(10,31,18,1) 100%)',
        border: '1px solid rgba(79,233,181,0.32)',
        borderRadius: 12,
        padding: '28px 32px',
        marginBottom: 18,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div className="eyebrow" style={{ color: 'var(--color-accent)' }}>▌ Personalized for you</div>
      <h2 style={{ fontSize: 24, fontWeight: 700, letterSpacing: '-0.02em', margin: '6px 0 10px', color: 'var(--color-text)' }}>
        Get a path through the 12 levels in 30 seconds.
      </h2>
      <p style={{ color: 'var(--color-text-2)', fontSize: 14, margin: '0 0 18px', maxWidth: 540 }}>
        Tell us your role and what you want to get out of this. Claude Sonnet 4.6 will pick which levels matter
        most for your day-to-day — and which you can skip.
      </p>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
        <button onClick={onBuild} className="btn btn-primary">▸ Build my AI plan</button>
        <button
          onClick={onSkip}
          style={{ background: 'transparent', color: 'var(--color-text-3)', border: 0, padding: '10px 16px', fontSize: 13, cursor: 'pointer' }}
        >
          Skip · use the curriculum as-is
        </button>
      </div>
    </div>
  );
}
